 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-2d0a370c":"e73fe867","chunk-2d0a511f":"c4b90bb0","chunk-2d0a51bd":"6840cf36","chunk-2d0ab0f5":"00e8cddd","chunk-2d0ac340":"b7b6b96c","chunk-2d0ac931":"cc71baa3","chunk-2d0ae8aa":"77ce9e13","chunk-2d0b1642":"3e3d349b","chunk-2d0b1dc5":"96e995bf","chunk-2d0b2938":"90c62c3a","chunk-2d0b5a28":"504fc2c5","chunk-2d0b957e":"69e2b46f","chunk-2d0b9f85":"f3da8a58","chunk-2d0ba0fd":"d965950d","chunk-2d0ba355":"1ecc9951","chunk-2d0ba36b":"d7192d1f","chunk-2d0be0fc":"4c3d489d","chunk-2d0c1056":"83a52c7c","chunk-2d0c211b":"56bba833","chunk-2d0ceb50":"44b16c8d","chunk-2d0cf315":"c8f5219d","chunk-2d0d098a":"55e4f7a1","chunk-2d0d2b9e":"fe75205a","chunk-2d0db2d2":"167ffc3e","chunk-2d0dd7b1":"1995b137","chunk-2d0f0c5c":"362b7f01","chunk-2d2079a6":"90b2b2bb","chunk-2d207ee6":"a8a18f49","chunk-2d2097bc":"dfd122b6","chunk-2d20feaa":"db034a33","chunk-2d2103ff":"72e8b58a","chunk-2d213e5b":"d87cc84f","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d21d068":"1037963c","chunk-2d222cca":"4226e9f6","chunk-2d2258b0":"22660cd2","chunk-2d228854":"0e76e7f2","chunk-2d22895d":"4ebcf334","chunk-2d2295c4":"af3d5c50","chunk-2d22c503":"709d947d","chunk-2d23721e":"7970ea5d","chunk-2d237d0e":"d4b8a76e","chunk-5fe53333":"fa243e21","chunk-60a534f5":"6bab549d","chunk-73d8cd7e":"29d99e27","chunk-ab8c3892":"b56a8761","chunk-02a693ea":"2f44a302","chunk-05df0c62":"09090ba4","chunk-068e9e35":"688c2403","chunk-12a6db97":"d0c623cf","chunk-146c3254":"3461dec3","chunk-201dbad2":"2adff506","chunk-242f73bf":"90ca5640","chunk-28e7db5e":"db593c1d","chunk-303e16d9":"ffa2eac5","chunk-32a6ed16":"da72cb20","chunk-364d83f1":"9cef9749","chunk-ee13c532":"ce7b5230","chunk-367a5279":"57087853","chunk-38b84a4e":"c9868719","chunk-3985ffd0":"3dff188c","chunk-41bdfe96":"07144231","chunk-423ef7fa":"04fb006f","chunk-470f3435":"59db3e8f","chunk-4933eb3c":"1a8983bd","chunk-4a27e07c":"5189b204","chunk-59780d80":"f514feee","chunk-5d4380ec":"004a8f6e","chunk-66c55524":"12f03ee3","chunk-6e24985c":"60632f10","chunk-7686e46d":"4089667a","chunk-0f9139b8":"482ccf63","chunk-661d6e32":"67aedcfc","chunk-7a9cb508":"d31870d4","chunk-9790beac":"cbedd5b4","chunk-bec26540":"22b33eef","chunk-c452c362":"be9dd7e5","chunk-d9d04bd4":"c5808465","chunk-e9c1b634":"f3c6a700","chunk-ec2a30da":"24f94c13","chunk-10efada4":"c1352f56","chunk-122bc624":"be30cab5","chunk-225bfa70":"5c4eb9a0","chunk-277d79ca":"4a2a2225","chunk-2d6dc6a4":"a72f8b82","chunk-22ac8008":"dac1caa4","chunk-57387c78":"2943588d","chunk-9dcea012":"7c49b5df","chunk-3ce36b90":"064a175a","chunk-5f424528":"bb4ad986","chunk-67521a26":"ca202419","chunk-6cb5948c":"2bbc0b11","chunk-352b3614":"9b60075a","chunk-4f2ad97e":"503507ff","chunk-7328fd87":"8d1bbe1c","chunk-760cc041":"1ab6b437","chunk-7a2c98a2":"3259d9f5","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-5fe53333":1,"chunk-60a534f5":1,"chunk-73d8cd7e":1,"chunk-ab8c3892":1,"chunk-02a693ea":1,"chunk-05df0c62":1,"chunk-068e9e35":1,"chunk-12a6db97":1,"chunk-146c3254":1,"chunk-201dbad2":1,"chunk-242f73bf":1,"chunk-28e7db5e":1,"chunk-303e16d9":1,"chunk-364d83f1":1,"chunk-ee13c532":1,"chunk-367a5279":1,"chunk-38b84a4e":1,"chunk-3985ffd0":1,"chunk-41bdfe96":1,"chunk-423ef7fa":1,"chunk-470f3435":1,"chunk-4933eb3c":1,"chunk-4a27e07c":1,"chunk-59780d80":1,"chunk-5d4380ec":1,"chunk-66c55524":1,"chunk-6e24985c":1,"chunk-7686e46d":1,"chunk-0f9139b8":1,"chunk-661d6e32":1,"chunk-7a9cb508":1,"chunk-9790beac":1,"chunk-bec26540":1,"chunk-c452c362":1,"chunk-d9d04bd4":1,"chunk-e9c1b634":1,"chunk-ec2a30da":1,"chunk-10efada4":1,"chunk-122bc624":1,"chunk-225bfa70":1,"chunk-277d79ca":1,"chunk-2d6dc6a4":1,"chunk-22ac8008":1,"chunk-57387c78":1,"chunk-9dcea012":1,"chunk-3ce36b90":1,"chunk-5f424528":1,"chunk-67521a26":1,"chunk-6cb5948c":1,"chunk-352b3614":1,"chunk-4f2ad97e":1,"chunk-7328fd87":1,"chunk-760cc041":1,"chunk-7a2c98a2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-2d0a370c":"31d6cfe0","chunk-2d0a511f":"31d6cfe0","chunk-2d0a51bd":"31d6cfe0","chunk-2d0ab0f5":"31d6cfe0","chunk-2d0ac340":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0ae8aa":"31d6cfe0","chunk-2d0b1642":"31d6cfe0","chunk-2d0b1dc5":"31d6cfe0","chunk-2d0b2938":"31d6cfe0","chunk-2d0b5a28":"31d6cfe0","chunk-2d0b957e":"31d6cfe0","chunk-2d0b9f85":"31d6cfe0","chunk-2d0ba0fd":"31d6cfe0","chunk-2d0ba355":"31d6cfe0","chunk-2d0ba36b":"31d6cfe0","chunk-2d0be0fc":"31d6cfe0","chunk-2d0c1056":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0ceb50":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d098a":"31d6cfe0","chunk-2d0d2b9e":"31d6cfe0","chunk-2d0db2d2":"31d6cfe0","chunk-2d0dd7b1":"31d6cfe0","chunk-2d0f0c5c":"31d6cfe0","chunk-2d2079a6":"31d6cfe0","chunk-2d207ee6":"31d6cfe0","chunk-2d2097bc":"31d6cfe0","chunk-2d20feaa":"31d6cfe0","chunk-2d2103ff":"31d6cfe0","chunk-2d213e5b":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21d068":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d2258b0":"31d6cfe0","chunk-2d228854":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2295c4":"31d6cfe0","chunk-2d22c503":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237d0e":"31d6cfe0","chunk-5fe53333":"fa7c7c28","chunk-60a534f5":"4f99c227","chunk-73d8cd7e":"d1f18a41","chunk-ab8c3892":"63116648","chunk-02a693ea":"8007f3b7","chunk-05df0c62":"6dfbcbd1","chunk-068e9e35":"ce338840","chunk-12a6db97":"97cc2949","chunk-146c3254":"98cebd45","chunk-201dbad2":"aaf09084","chunk-242f73bf":"8007f3b7","chunk-28e7db5e":"3179839d","chunk-303e16d9":"8007f3b7","chunk-32a6ed16":"31d6cfe0","chunk-364d83f1":"ecb1a1d6","chunk-ee13c532":"7f45164b","chunk-367a5279":"8007f3b7","chunk-38b84a4e":"8f754932","chunk-3985ffd0":"bdd54482","chunk-41bdfe96":"2b7e931d","chunk-423ef7fa":"98cebd45","chunk-470f3435":"d6fb1499","chunk-4933eb3c":"98cebd45","chunk-4a27e07c":"531a0386","chunk-59780d80":"63358304","chunk-5d4380ec":"49ed1af3","chunk-66c55524":"16675222","chunk-6e24985c":"97cc2949","chunk-7686e46d":"ef4f9b74","chunk-0f9139b8":"7d226e2f","chunk-661d6e32":"5253e49c","chunk-7a9cb508":"0b11c002","chunk-9790beac":"6342931a","chunk-bec26540":"26e80125","chunk-c452c362":"ed6f586b","chunk-d9d04bd4":"98cebd45","chunk-e9c1b634":"d824b969","chunk-ec2a30da":"5ae5a0ed","chunk-10efada4":"fa18f807","chunk-122bc624":"32bd5ea9","chunk-225bfa70":"58e80e57","chunk-277d79ca":"22cc6899","chunk-2d6dc6a4":"3c6b461f","chunk-22ac8008":"0ed7e5a3","chunk-57387c78":"0ed7e5a3","chunk-9dcea012":"0ed7e5a3","chunk-3ce36b90":"0970b164","chunk-5f424528":"5006f994","chunk-67521a26":"d0dfae3d","chunk-6cb5948c":"b5790564","chunk-352b3614":"0a83fa9f","chunk-4f2ad97e":"663525e4","chunk-7328fd87":"19123428","chunk-760cc041":"be8a0f04","chunk-7a2c98a2":"752e1d16","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
